module.exports = __webpack_public_path__ + "img/after-5.a047428e.png";